import { type ApiResponse } from '@/api/core/_models';
import { createMockTicketRequests } from './_mockRequests';
import { type Ticket, type TicketDepartment, type TicketOpenInput, type TicketSlaDeadline } from './_models';

const ticketMockRequests = createMockTicketRequests();

export function listTickets(): Promise<ApiResponse<Ticket[]>> {
  return ticketMockRequests.listTickets();
}

export function getTicket(id: string): Promise<ApiResponse<Ticket>> {
  return ticketMockRequests.getTicket(id);
}

export function replyToTicket(id: string, text: string): Promise<ApiResponse<Ticket>> {
  return ticketMockRequests.replyToTicket(id, text);
}

export function openTicket(input: TicketOpenInput): Promise<ApiResponse<Ticket>> {
  return ticketMockRequests.openTicket(input);
}

export function getCatalog(): Promise<ApiResponse<TicketDepartment[]>> {
  return ticketMockRequests.getCatalog();
}

export function listSlaDeadlines(): Promise<ApiResponse<TicketSlaDeadline[]>> {
  return ticketMockRequests.listSlaDeadlines();
}
